import loadingGif from "@/assets/imgs/loading.gif";
import loadingMinGif from "@/assets/imgs/loading-min.gif";
import { LanguageToggle } from "@/components/language-toggle";
import { useI18n } from "@/locales/i18n-provider";
import { cn } from "@/utils/index";

type LoadingScreenProps = {
  /** page：整页加载（大图）；oidc：鉴权流程处理事件（小图）；inline：嵌入端，占满容器且不带语言入口 */
  variant?: "page" | "oidc" | "inline";
  title?: string;
  detail?: string;
};

/** 全屏居中的品牌加载态，供页面加载与 OIDC 处理事件共用。 */
export function LoadingScreen({ variant = "page", title, detail }: LoadingScreenProps) {
  const { t } = useI18n();
  const isPage = variant === "page";
  // 嵌入端不提供独立的语言入口，外观完全由宿主推送（docs/embedded-workbench-design.md §5.3）。
  const isInline = variant === "inline";

  return (
    <main className={cn("grid place-items-center bg-background px-6", isInline ? "h-full min-h-60 py-10" : "min-h-dvh py-12")}>
      {isInline ? null : (
        <div className="fixed right-4 top-4">
          <LanguageToggle />
        </div>
      )}
      <div className="flex flex-col items-center text-center">
        <img alt={t("loading.alt")} height={100} width={100} src={isPage ? loadingGif : loadingMinGif} />
        {title ? <h1 className="mt-1 text-lg font-semibold text-foreground">{title}</h1> : null}
        {detail ? <p className="mt-2 max-w-sm text-sm leading-6 text-muted-foreground">{detail}</p> : null}
      </div>
    </main>
  );
}
